import {axiosInstance} from "../utils/axios";

export const createVirtualClass = (virtualClass) => {
    return axiosInstance.post('teachers/add/virtual-class', virtualClass);
};

export const updateVirtualClass = (virtualClass) => {
    return axiosInstance.put(`/teachers/virtual-class/${virtualClass.id}`, virtualClass)
}

export const getAllVirtualClassesRTQ = () => {
    return axiosInstance.get('teachers/virtual-classes');
}

export const getClassByIdRTQ = ({queryKey}) => {
    if (!queryKey[1])
        return;

    return getClassById(queryKey[1]);
}

export const getClassById = (classId) => {
    if (!classId)
        return;

    return axiosInstance.get(`${classId}`);
};

